import styles from './EmailTemplatePreview.module.scss';

import { useMemo } from 'react';

import { usePageZoom } from '@work4all/data';

import { EMailTemplate } from '@work4all/models/lib/Classes/EMailTemplate.entity';

import { PreviewTitle, PreviewWrapper } from '../components';
import { setDefaultHeadStyles } from '../utils';

export type IEmailTemplatePreviewProps = {
  emailTemplate: EMailTemplate;
  onCloseClick?: React.MouseEventHandler<HTMLButtonElement>;
  onEditClicked?: React.MouseEventHandler<HTMLButtonElement>;
  onVisibilityToggle?: (visible: boolean) => void;
};

export function EmailTemplatePreview(props: IEmailTemplatePreviewProps) {
  const { emailTemplate, onCloseClick, onEditClicked, onVisibilityToggle } =
    props;

  const body = useMemo(() => {
    let result = emailTemplate?.body;

    if (emailTemplate?.signature?.body) {
      result += emailTemplate?.signature?.body;
    }
    return result;
  }, [emailTemplate?.body, emailTemplate?.signature?.body]);

  const { zoomLevel } = usePageZoom();

  return (
    <PreviewWrapper>
      <div className={styles.wrap}>
        <PreviewTitle
          onCloseClick={onCloseClick}
          onEditClicked={onEditClicked}
          onVisibilityToggle={onVisibilityToggle}
        >
          {emailTemplate.name}
        </PreviewTitle>

        <iframe
          className={styles.content}
          title="Email template Preview"
          srcDoc={
            setDefaultHeadStyles({
              value: body || '',
              textmarkStyles: true,
              zoom: zoomLevel,
            }) || body
          }
        />
      </div>
    </PreviewWrapper>
  );
}
